import axios from "axios";
class ApiBlockedUsers {
    static async GetList(session_uuid) {
        try {
            const result = await axios.get("/api/admin/blocked-users/list", {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid,
                },
            });
            return result.data.response;
        }
        catch (e) {
            throw new Error("Error get blocked users");
        }
    }
    static async GetDetails(session_uuid, uuid) {
        try {
            const result = await axios.get("/api/admin/blocked-users/details", {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid,
                },
                params: { uuid },
            });
            return result.data.response;
        }
        catch (e) {
            throw new Error("Error get blocked user details");
        }
    }
    static async Create(session_uuid, email, fiscalCode, phone) {
        try {
            const payload = {};
            if (email)
                payload.email = email;
            if (fiscalCode)
                payload.fiscalCode = fiscalCode;
            // Il +39 e' un prefisso fisso nel form: l'utente inserisce solo il numero nazionale.
            if (phone)
                payload.phone = "+39" + phone;
            const result = await axios.post("/api/admin/blocked-users/create", payload, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid,
                },
            });
            return result.data.response;
        }
        catch (e) {
            return false;
        }
    }
    static async Update(session_uuid, uuid, email, fiscalCode, phone) {
        try {
            const payload = { uuid };
            if (email)
                payload.email = email;
            if (fiscalCode)
                payload.fiscalCode = fiscalCode;
            // Il +39 e' un prefisso fisso nel form: l'utente inserisce solo il numero nazionale.
            if (phone)
                payload.phone = "+39" + phone;
            const result = await axios.post("/api/admin/blocked-users/update", payload, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid,
                },
            });
            return result.data.response;
        }
        catch (e) {
            return false;
        }
    }
    static async Delete(session_uuid, uuid) {
        try {
            const result = await axios.post("/api/admin/blocked-users/delete", { uuid }, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid,
                },
            });
            return result.data.response;
        }
        catch (e) {
            return false;
        }
    }
}
export default ApiBlockedUsers;
